export default {
  watch: {
    Canvas: { handler() { this.register(this.draw) }, deep: true },
    Text: { handler(val) { if(!val || Object.keys(val).length === 0) return; this.register(this.draw); }, deep: true },

    ModalDraw: { handler() { this.register(this.draw) }, deep: true },
    ModalTaps: { handler() { this.register(this.draw) }, deep: true },

    DataItems: { handler(val) { if(!val || val.length === 0) return; this.register(this.draw) }, deep: true },
  },
}
